import { useStaticQuery, graphql } from 'gatsby'

/**
 * Transforms author data from WordPress to a more structured format.
 *
 * @param {Object} author - The author data from WordPress.
 * @returns {Object} An object containing the transformed author data.
 */
export const transformAuthorData = author => ({
  id: author.id,
  name: author.name,
  avatar: author.userSettings?.profileImg?.sourceUrl || author.avatar?.url,
  avatarAlt: author.userSettings?.profileImg?.altText || author.avatar?.altText,
  link: author.uri,
  title: author.userSettings?.title,
  description: author.description,
  email: author.email,
  role: author.roles?.nodes[0].name,
})

const mapDataToWriters = data => {
  return data?.map(author => transformAuthorData(author))
}

export const useAllWritersQuery = () => {
  const data = useStaticQuery(graphql`
    {
      allWpUser(
        filter: {
          roles: { nodes: { elemMatch: { name: { in: ["contributor"] } } } }
        }
      ) {
        nodes {
          id
          name
          roles {
            nodes {
              name
              id
            }
          }
          uri
          slug
          avatar {
            url
          }

          userSettings {
            profileImg {
              altText
              sourceUrl
            }
            title
          }
        }
      }
    }
  `)

  return mapDataToWriters(data?.allWpUser?.nodes)
}
